import { createContext } from 'react';
// eslint-disable-next-line max-len
import { EndorsementServiceFeaturesGetOwnEndorsementsGetOwnEndorsementsDto as EndorsementDto } from '@sdir/httpclient/lib/clients/aps/endorsement';
import { Loadable } from '../../types';

export interface IOwnEndorsementContext {
  ownEndorsements: Loadable<EndorsementDto[]>;
  refresh?: () => void;
}

export const OwnEndorsementContext = createContext<IOwnEndorsementContext>({
  ownEndorsements: {
    loading: false,
    result: null,
    error: null,
  },
});
